import {AfterContentInit, Component, ViewChild} from '@angular/core';
import {Validators}                             from '@angular/forms';
import {Observable}                             from 'rxjs';
import {ApMenuUrls}                             from '../../ap-interface';
import {ApDynformsComponent}                    from '../../ap-dynforms/ap-dynforms.component';
import {ApDynformsConfigFieldset} from '../../ap-dynforms/config/ap-dynforms-config-fieldset';
import {
  ApDynformsConfigTextbox,
  ApDynformsConfigTextboxType
}                                 from '../../ap-dynforms/config/ap-dynforms-config-textbox';
import {ApDynformsValidator}      from '../../ap-dynforms/ap-dynforms-validator';
import {LoginStore}                             from '../../stores/login/login.store';
import {PasswordStore}                          from '../../stores/login/password.store';

/**
 * Component for the request password reset
 */
@Component({
  selector: 'ap-request-password-reset',
  templateUrl: 'ap-request-password-reset.component.html',
})
export class ApRequestPasswordResetComponent implements AfterContentInit {
  @ViewChild(ApDynformsComponent, {static: true}) dynForm: ApDynformsComponent;
  private emailAddressFormKey = 'emailAddress';
  public formConfig: ApDynformsConfigFieldset[];
  public caption: string;
  public emailAddress$: Observable<string>;
  public emailMessage$: Observable<string>;
  public isEmailAddressSend$: Observable<boolean>;
  public loginLoading$: Observable<boolean>;
  public ApMenuUrls = ApMenuUrls;
  public passwordLoading$: Observable<boolean>;

  constructor(private loginStore: LoginStore,
              private passwordStore: PasswordStore) {
    this.formConfig = [
      new ApDynformsConfigFieldset({
        key: 'reset_password_fieldset',
        columns: 1,
        legend: 'Admin_Pages_Login_Reset_Password',
        label: 'Admin_Pages_Login_Reset_Password_Tip',
        asyncTranslation: true,
        config: [
          new ApDynformsConfigTextbox({
            key: this.emailAddressFormKey,
            label: 'Global__Email',
            value: '',
            type: ApDynformsConfigTextboxType.Email,
            validators: [new ApDynformsValidator({
              validator: Validators.required,
              errorKey: 'Admin_Pages_Login_Reset_Password_Email_Error'
            }),
              new ApDynformsValidator({
                validator: Validators.minLength(1),
                errorKey: 'Admin_Pages_Login_Reset_Password_Email_Error'
              }),
              new ApDynformsValidator({
                validator: Validators.pattern('^[-_.\\w]+@([0-9a-zA-Z][-\\w]*[0-9a-zA-Z]\\.){1,300}[a-zA-Z]{2,9}$'),
                errorKey: 'Admin_Pages_Login_Reset_Password_Email_Error'
              })]
          }),
        ]
      })
    ];
  }

  /**
   * when the component is loaded
   */
  ngAfterContentInit(): void {
    this.getDataFromStore();
  }

  /**
   * retrieves all data from the store
   */
  getDataFromStore(): void {
    this.emailAddress$ = this.loginStore.EmailAddress$;
    this.emailMessage$ = this.loginStore.Message$;
    this.isEmailAddressSend$ = this.loginStore.IsEmailAddressSend$;
    this.loginLoading$ = this.loginStore.LoginLoading$;
    this.passwordLoading$ = this.passwordStore.PasswordLoading$;
  }

  /**
   * on submit click event
   */
  onSubmit(): void {
    this.passwordStore.forgotPassword(this.dynForm.form.get(this.emailAddressFormKey).value);

  }
}

